import { flexRender, type Table } from '@tanstack/react-table';
import type React from 'react';
import { getListViewColumnStyle, getListViewFillColumnId } from './ListViewColumnSizing';
import type { ListViewRow } from './listView.types';

interface ListViewHeaderProps {
  table: Table<ListViewRow>;
  classes: Record<string, string>;
}

const ListViewHeader: React.FC<ListViewHeaderProps> = ({ table, classes }) => {
  const visibleColumnIds = table.getVisibleLeafColumns().map((column) => column.id);
  const fillColumnId = getListViewFillColumnId(visibleColumnIds);

  return (
    <>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className={classes.headerRow}>
          {headerGroup.headers.map((header) => {
            const sizeStyle = getListViewColumnStyle(header.column.id, header.getSize(), fillColumnId);

            return (
              <th key={header.id} className={classes.headerCell} style={sizeStyle}>
                {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                {header.column.getCanResize() && (
                  // biome-ignore lint/a11y/noStaticElementInteractions: resize handle is mouse/touch interactive
                  <div
                    onMouseDown={header.getResizeHandler()}
                    onTouchStart={header.getResizeHandler()}
                    className={`${classes.resizeHandle} ${header.column.getIsResizing() ? 'isResizing' : ''}`}
                  />
                )}
              </th>
            );
          })}
        </tr>
      ))}
    </>
  );
};

export default ListViewHeader;
